import React from 'react';
import LqwVltMap from './lqwVltMap';
import { connect } from 'react-redux';
import {compassIcon ,homeIcon,antennaIcon} from './map-icons.js';
import styled from 'styled-components';
import { store } from '../../reducers/configure-store';
import HereMap from './hereMap';

const Compass = styled.div`
  z-index:1;
  position:absolute;
  top: 30%;
  left: 93%;
`;
export const mmWave = (map)=>{
  const storeData = store.getState();
  const coords = storeData.compassApp.coords;
  map.addSource('Sgnl', {
        'type': 'geojson',
        'data': {
        'type': 'Feature',
        'properties': {},
        'geometry': {
        'type': 'LineString',
        'coordinates': coords ? coords : []
               }
        }
        });
        map.addLayer({
          'id': 'Sgnl',
          'type': 'line',
          'source': 'Sgnl',
          'layout': {
          'line-join': 'round',
          'line-cap': 'round'
          },
          'paint': {
          'line-color': '#5B8930',
          'line-width': 4
          }
          });
};
class CompassMapContainer extends React.PureComponent {
  constructor(props) {
    super(props); 
    this.compassIcon=compassIcon;
    this.homeIcon=homeIcon;
    this.antennaIcon=antennaIcon;
  }
  
  getMarkerList = (state) => {
    const compassState = this.props.compassApp; 
    const params = new URLSearchParams(window.location.search);
    const NBType = params.get('NetworkBandWidthType');
    const NetworkBandWidthType = NBType === 'MMW' ? true : false;
    const eagleSignalLines = window.location.pathname.includes('verizon-receiver') || NetworkBandWidthType ? true : false;
    let markerList = [];
    if(compassState && !eagleSignalLines){
      const customerLocation = {
        latitude: compassState.lat,
        longitude:  compassState.lgt,
      }   
      markerList.push( 
        this.createMarker(customerLocation,this.homeIcon)

      );
      if (state.nodes && state.nodes.length) {
        state.nodes.forEach(val => {
          markerList.push(
            this.createMarker(val,this.antennaIcon)
          );
        })       
      }
    }   
    return markerList;
  };

  createMarker(marker, markerIcons) {
     return {
       coordinates:{lng:marker.longitude,lat:marker.latitude},
       draggable:false,
       icon:markerIcons,
       properties:{}
     }
    }


  render() {
    const Compic = compassIcon();
    const isHereMap=window.location.search.indexOf('heremap=y')>-1?true:false;
    const isvltMap =(window.location.search.includes('vltMap=Y')) ?true:false;
    const params = new URLSearchParams(window.location.search);
    const NBType = params.get('NetworkBandWidthType');
    const NetworkBandWidthType = NBType === 'MMW' ? true : false;
    const eagleSignalLines = window.location.pathname.includes('verizon-receiver') || NetworkBandWidthType ? true : false;
    return (
      <>
        <Compass>{Compic}</Compass>
        { isvltMap && this.props.compassApp.lgt && this.props.compassApp.lat && 
        <LqwVltMap 
          id={this.props.id} 
          zoomIndex={this.props.compassApp.coords && this.props.compassApp.coords.length !== 0 ? 19 : 13}
          center={{lng: this.props.compassApp.lgt, lat: this.props.compassApp.lat}}
          markers={this.getMarkerList(this.props.compassApp)}>          
        </LqwVltMap>
        }
        { !isvltMap && this.props.compassApp.lgt && this.props.compassApp.lat && 
        <HereMap
           id="myMap"
           zoomIndex={this.props.compassApp.coords && this.props.compassApp.coords.length !== 0 ? 19 : 13}
           compassApp={this.props.compassApp}
           eagleSignalLines ={eagleSignalLines}
        >
        </HereMap>
        }
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    compassApp:state.compassApp,
  };
};

export default connect(mapStateToProps)(CompassMapContainer);